import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-quiz-binary-toggle',
  templateUrl: './quiz-binary-toggle.component.html',
  styleUrls: ['./quiz-binary-toggle.component.css']
})
export class QuizBinaryToggleComponent {

  @Input() leftLabel: string = 'left';
  @Input() rightLabel: string = 'right';
  @Input() isLeftSelected: boolean = true;

  @Output() isLeftSelectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
  }

  select() {
    this.isLeftSelected = !this.isLeftSelected;
    this.isLeftSelectedChange.emit(this.isLeftSelected);
  }
}
